function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect, useContext } from 'react';
import { connect, useSelector } from 'react-redux';
import { cmsActions } from '../../../reducers/cms.reducer';
import permissionGroupDict from '../../../helpers/dictionary/permissionGroupDict';
import UserData from './User.context';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import Checkbox from '../../common/form/Checkbox.react';
var UserPermissions = function UserPermissions(_ref) {
  var usersAction = _ref.usersAction,
    permissionsAction = _ref.permissionsAction;
  var _useContext = useContext(UserData),
    _useContext2 = _slicedToArray(_useContext, 1),
    state = _useContext2[0];
  var userID = state.userID,
    permissions = state.permissions;
  var cmsPermissions = useSelector(function (s) {
    var _s$cms;
    return ((_s$cms = s.cms) === null || _s$cms === void 0 ? void 0 : _s$cms.permissions) || {};
  });
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    permissionGroups = _useState2[0],
    setPermissionGroups = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    permissionObj = _useState4[0],
    setPermissionObj = _useState4[1];
  useEffect(function () {
    permissionsAction({});
  }, []);
  useEffect(function () {
    var obj = {};
    permissions.forEach(function (x) {
      obj[x.key] = x.value;
    });
    setPermissionObj(obj);
  }, [permissions]);
  useEffect(function () {
    var obj = {};
    Object.values(cmsPermissions).forEach(function (x) {
      if (!(x.group in obj)) obj[x.group] = [];
      obj[x.group].push(x);
    });
    setPermissionGroups(obj);
  }, [state, cmsPermissions]);
  var updatePermission = function updatePermission(_ref2) {
    var permission = _ref2.permission,
      val = _ref2.val;
    usersAction({
      formData: {
        userID: userID,
        permission: permission,
        val: val
      },
      method: 'put',
      route: 'update-permission'
    });
    setPermissionObj(_objectSpread(_objectSpread({}, permissionObj), {}, _defineProperty({}, permission, val)));
  };
  var layout = ['site-access', 'edit-content', 'developer'];
  var cmsAccess = [{
    title: 'Posillico Inc',
    key: 'view-posillico'
  }, {
    title: 'Posillico Materials',
    key: 'view-materials'
  }, {
    title: 'Posillico Wash Plant',
    key: 'view-washplant'
  }, {
    title: 'PPark',
    key: 'view-ppark'
  }, {
    title: 'Construx',
    key: 'view-construx'
  }, {
    title: 'Assets',
    key: 'view-assets'
  }, {
    title: 'CMS Settings',
    key: 'view-settings'
  }];
  var posAccess = [{
    title: 'Edit Navigation',
    key: 'edit-pos-navigation'
  }, {
    title: 'Edit Sections',
    key: 'edit-pos-sections'
  }, {
    title: 'Edit Articles',
    key: 'edit-pos-articles'
  }, {
    title: 'Edit Popup Windows',
    key: 'edit-pos-popup'
  }, {
    title: 'Edit Contacts',
    key: 'edit-pos-contacts'
  }];
  var pparkAccess = [{
    title: 'Edit Navigation',
    key: 'edit-ppark-navigation'
  }, {
    title: 'Edit Sections',
    key: 'edit-ppark-sections'
  }, {
    title: 'Edit Products',
    key: 'edit-ppark-products'
  }, {
    title: 'Edit Services',
    key: 'edit-ppark-services'
  }, {
    title: 'Edit Associations',
    key: 'edit-ppark-associations'
  }, {
    title: 'Edit FAQ',
    key: 'edit-ppark-faq'
  }, {
    title: 'Edit Forms',
    key: 'edit-ppark-forms'
  }, {
    title: 'Edit Contact Persons',
    key: 'edit-ppark-contacts'
  }, {
    title: 'Site Settings',
    key: 'edit-ppark-settings'
  }];
  var construxAccess = [{
    title: 'Edit Navigation',
    key: 'edit-construx-navigation'
  }, {
    title: 'Edit Sections',
    key: 'edit-construx-sections'
  }, {
    title: 'Edit Products',
    key: 'edit-construx-products'
  }, {
    title: 'Edit Services',
    key: 'edit-construx-services'
  }, {
    title: 'Edit Associations',
    key: 'edit-construx-associations'
  }, {
    title: 'Edit Clients',
    key: 'edit-construx-clients'
  }, {
    title: 'Edit FAQ',
    key: 'edit-construx-faq'
  }, {
    title: 'Edit Forms',
    key: 'edit-construx-forms'
  }, {
    title: 'Edit Contact Persons',
    key: 'edit-construx-contacts'
  }];
  var projectPortalAccess = [{
    title: 'Edit Company Data',
    key: 'edit-materials-pp-companies'
  }, {
    title: 'Edit Users',
    key: 'edit-materials-pp-users'
  }, {
    title: 'Edit Projects',
    key: 'edit-materials-pp-projects'
  }, {
    title: 'View Credit Card Details',
    key: 'view-materials-pp-credit-cards'
  }];
  var developerAccess = [{
    title: 'View Permissions',
    key: 'view-permissions'
  }, {
    title: 'View Constants',
    key: 'view-constants'
  }, {
    title: 'Email Logs',
    key: 'view-email-logs'
  }, {
    title: 'Email Test Kit',
    key: 'view-email-test-kit'
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Change Permissions"
  }), /*#__PURE__*/React.createElement(CardBody, {
    className: "user-permissions"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, "CMS Access"), /*#__PURE__*/React.createElement("div", null, cmsAccess.map(function (x) {
    return /*#__PURE__*/React.createElement(Checkbox, {
      checked: permissionObj[x.key] || false,
      onChange: function onChange(val) {
        updatePermission({
          permission: x.key,
          val: val
        });
      },
      label: x.title,
      permission: "edit-permissions",
      key: JSON.stringify(x)
    });
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, "Posillico"), /*#__PURE__*/React.createElement("div", null, posAccess.map(function (x) {
    return /*#__PURE__*/React.createElement(Checkbox, {
      checked: permissionObj[x.key] || false,
      onChange: function onChange(val) {
        updatePermission({
          permission: x.key,
          val: val
        });
      },
      label: x.title,
      permission: "edit-permissions",
      key: JSON.stringify(x)
    });
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, "PPark"), /*#__PURE__*/React.createElement("div", null, pparkAccess.map(function (x) {
    return /*#__PURE__*/React.createElement(Checkbox, {
      checked: permissionObj[x.key] || false,
      onChange: function onChange(val) {
        updatePermission({
          permission: x.key,
          val: val
        });
      },
      label: x.title,
      permission: "edit-permissions",
      key: JSON.stringify(x)
    });
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, "Construx"), /*#__PURE__*/React.createElement("div", null, construxAccess.map(function (x) {
    return /*#__PURE__*/React.createElement(Checkbox, {
      checked: permissionObj[x.key] || false,
      onChange: function onChange(val) {
        updatePermission({
          permission: x.key,
          val: val
        });
      },
      label: x.title,
      permission: "edit-permissions",
      key: JSON.stringify(x)
    });
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, "Project Portal"), /*#__PURE__*/React.createElement("div", null, projectPortalAccess.map(function (x) {
    return /*#__PURE__*/React.createElement(Checkbox, {
      checked: permissionObj[x.key] || false,
      onChange: function onChange(val) {
        updatePermission({
          permission: x.key,
          val: val
        });
      },
      label: x.title,
      permission: "edit-permissions",
      key: JSON.stringify(x)
    });
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, "Developer"), /*#__PURE__*/React.createElement("div", null, developerAccess.map(function (x) {
    return /*#__PURE__*/React.createElement(Checkbox, {
      checked: permissionObj[x.key] || false,
      onChange: function onChange(val) {
        updatePermission({
          permission: x.key,
          val: val
        });
      },
      label: x.title,
      permission: "edit-permissions",
      key: JSON.stringify(x)
    });
  }))))));
};
var mdtp = {
  usersAction: cmsActions.users,
  permissionsAction: cmsActions.permissions
};
export default connect(null, mdtp)(UserPermissions);